<template>
  <div class="bg">
    <div class="title">系统公告</div>
    <div class="tips">
      <div class="tips-top"><img src="../../assets/ts.png" />重要提示</div>
      <div class="msg">
        根据系统升级安排，我们已于 2025 年 5 月 1 日启用新的投稿系统。请您务必根据投稿
        时间选择正确的系统入口，以确保您的投稿得到及时处理。
      </div>
    </div>
    <div class="content">
      <div style="margin-right: 24px">
        <img src="../../assets/x.png" />
        <p>新系统入口</p>
        <div>适用于 2025 年 5 月 1 日后的投稿</div>
        <span @click="jump('oa')"> 进入新系统 </span>
      </div>
      <div>
        <img src="../../assets/j.png" />
        <p>原系统入口</p>
        <div>适用于 2025 年 5 月 1 日前的投稿</div>
        <span style="background-color: #64748b" @click="jump('Admin/user/login')">
          进入原系统
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    jump(path) {
      window.open(path + "?group=" + this.$route.query.path + "&isselected=1");
    },
  },
};
</script>

<style lang="scss" scoped>
.bg {
  padding-top: 100px;
  background: url("../../assets/bg.jpg") no-repeat 100% 100%;
  background-size: 100% 100%;
  height: 100vh;
  box-sizing: border-box;
}
.title {
  text-align: center;
  height: 60px;
  font-family: PingFang SC;
  font-size: 45px;
  font-weight: 600;
  line-height: 60px;
  text-align: center;
  letter-spacing: 0px;
  font-variation-settings: "opsz" auto;
  color: rgba(0, 0, 0, 0.85);
  box-sizing: border-box;
}
.tips {
  box-sizing: border-box;
  padding: 24px 18px 25px 24px;
  margin: 50px auto 60px;
  width: 702px;
  height: 137px;
  border-radius: 8px;
  opacity: 1;
  /* 自动布局 */
  padding: 24px;
  background: #eff6ff;
  box-sizing: border-box;
  border: 1px solid #dbeafe;
  &-top {
    display: flex;
    align-items: center;
    font-family: PingFang SC;
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: 0px;
    font-variation-settings: "opsz" auto;
    color: #111827;
    img {
      margin-right: 16px;
      width: 20px;
      height: 20px;
    }
  }
  .msg {
    padding-left: 36px;
    margin-top: 8px;
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: normal;
    line-height: 26px;
    letter-spacing: 0px;
    font-variation-settings: "opsz" auto;
    color: rgba(0, 0, 0, 0.85);
    box-sizing: border-box;
  }
}
.content {
  display: flex;
  justify-content: center;
  > div {
    width: 340px;
    height: 233px;
    border-radius: 16px;
    /* 自动布局 */
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px;
    align-content: center;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid #e5e7eb;
    p {
      margin: 17px 0 9px;
      font-family: PingFang SC;
      font-size: 20px;
      font-weight: 600;
      line-height: 28px;
      letter-spacing: 0px;
      color: rgba(0, 0, 0, 0.85);
    }
    div {
      margin-bottom: 24px;
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      text-align: center;
      letter-spacing: 0px;
      color: rgba(0, 0, 0, 0.65);
    }
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      /* 自动布局子元素 */
      width: 292px;
      height: 48px;
      border-radius: 8px;
      padding: 12px 24px;
      /* 主题色蓝色 */
      background: #1867e3;
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: normal;
      line-height: 24px;
      text-align: center;
      letter-spacing: 0px;
      color: #ffffff;
      z-index: 0;
      cursor: pointer;
      box-sizing: border-box;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nav/checkout.vue